const signalR = require("@microsoft/signalr");
import { mapState, mapMutations } from "vuex";
import { api_GetStoreItemList, api_StoreBuyItem } from "@/api";
import { conversion, countDownS, GetItemDuration, formatDate } from "@/tool";
import Picture from "@/components/picture";
import Button from "@/components/button";
import Avatar from "@/components/avatar";
import Award from "@/components/award2";
import { CustomBlockTitle } from "@/partials/custom_block_title";
import InteractivePanel from "@/components/interactive_panel";
import battle_detail from "@/pages/battle/battle_detail";

export default {
  name: "cashshop",

  components: {
    "c-picture": Picture,
    "c-button": Button,
    "c-avatar": Avatar,
    "c-award": Award,
    "p-custom-block-title": CustomBlockTitle,
    "c-interactive-panel": InteractivePanel,
    "c-battle_detail": battle_detail,
  },

  filters: {
    conversion,
    GetItemDuration,
  },

  data() {
    return {
      totalPage: 0,
      totalItems: 0,
      page: 1,
      pageSize: 24,
      category: 0,
      sort_price: 0,
      search_name: "",
      price_range: 0,
      sub_catetoryId: 0, //当前子分类ID
      sub_catetory_name: "",
      isFirst: true,
      cartItemList: [],
      list_assets_data: {
        categories: [
          {
            id: 0, //分类id
            name: "ALL", //分类名称
            imgUrl: require("@/assets/images/itemstore/menu-all.png"),
            sub_catetory: [],
          },
          {
            id: 1, //分类id
            name: "步枪", //分类名称
            imgUrl: require("@/assets/images/itemstore/rifle.png"),
            sub_catetory: [
              "不限",
              "AK-47",
              "M4A1 消音型",
              "M4A4",
              "SG 553",
              "加利尔",
              "法玛斯",
            ],
          },
          {
            id: 2, //分类id
            name: "狙击枪", //分类名称
            imgUrl: require("@/assets/images/itemstore/awp.png"),
            sub_catetory: ["不限", "AWP", "SCAR-20", "SSG 08"],
          },
          {
            id: 3, //分类id
            name: "冲锋枪", //分类名称
            imgUrl: require("@/assets/images/itemstore/assault_rifle.png"),
            sub_catetory: [
              "不限",
              "P90",
              "MAC-10",
              "UMP-45",
              "MP7",
              "PP-野牛",
              "MP9",
              "MP5-SD",
            ],
          },
          {
            id: 4, //分类id
            name: "手枪", //分类名称
            imgUrl: require("@/assets/images/itemstore/pistal.png"),
            sub_catetory: [
              "不限",
              "P2000",
              "USP 消音版",
              "格洛克 18 型",
              "P250",
              "FN57",
              "CZ75 自动手枪",
              "Tec-9",
              "R8 左轮手枪",
              "沙漠之鹰",
              "双持贝瑞塔",
            ],
          },
          {
            id: 5, //分类id
            name: "匕首", //分类名称
            imgUrl: require("@/assets/images/itemstore/knife.png"),
            sub_catetory: [
              "不限",
              "鲍伊猎刀",
              "蝴蝶刀",
              "弯刀",
              "折叠刀",
              "穿肠刀",
              "猎杀者匕首",
              "M9 刺刀",
              "刺刀",
              "爪子刀",
              "暗影双匕",
              "短剑",
              "熊刀",
              "折刀",
              "锯齿爪刀",
              "海豹短刀",
              "系绳匕首",
              "求生匕首",
              "流浪者匕首",
              "骷髅匕首",
            ],
          },
          {
            id: 6, //分类id
            name: "手套", //分类名称
            imgUrl: require("@/assets/images/itemstore/gloves.png"),
            sub_catetory: [
              "不限",
              "血猎手套",
              "驾驶手套",
              "手部束带",
              "摩托手套",
              "专业手套",
              "运动手套",
              "九头蛇手套",
              "狂牙手套",
            ],
          },
          {
            id: 7, //分类id
            name: "霰弹枪", //分类名称
            imgUrl: require("@/assets/images/itemstore/heavy_weapons.png"),
            sub_catetory: ["不限", "截短霰弹枪", "XM1014", "新星", "MAG-7"],
          },
          {
            id: 8, //分类id
            name: "机枪", //分类名称
            imgUrl: require("@/assets/images/itemstore/neigefu.png"),
            sub_catetory: ["不限", "M249", "内格夫"],
          },
          {
            id: 9, //分类id
            name: "其他", //分类名称
            imgUrl: require("@/assets/images/itemstore/other.png"),
            sub_catetory: [],
          },
        ],

        items: [],
      },
      produceList: [],
      cartItemList: [],
      /** 确认购买 模态框 */
      confirm_modal: {
        flag: false,
        price: 0,
        item: null,
      },
      notice_modal_show: false,

    };
  },
  watch: {
    currentShopType() {
      this.list_assets_data.items = [];
      this.page = 1;
      this.totalPage = 0;
      this.totalItems = 0;
      this.cartItemList = [];
      this.getList();
    }
  },
  computed: {
    ...mapState(["user"]),
    currentShopType() {
      return this.$route.name;
    },
    totalCartPice() {
      return this.cartItemList.reduce((a, b) => {
        return a + b.price;
      }, 0);
    },
    active_produce_list() {
      return this.list_assets_data.items;
    },
  },
  created() {
    // this.price_range = 5; //默认加载价格区间在2000-10000的数据
    console.log("this.$route.name=", this.$route.name);
    this.getList();
  },
  beforeDestroy() { },

  methods: {
    ...mapMutations(["setSpinShow"]),
    //翻页
    pageF(v) {
      this.page = v;
      this.getList();
    },
    searchSubCat(name, sub_cat, index) {
      this.category = index;
      this.search_name = "";
      this.sub_catetoryId = 0;
      this.page = 1;
      this.sub_catetoryId = sub_cat;
      if (name === "不限") this.sub_catetory_name = "";
      else this.sub_catetory_name = name;

      this.getList();
    },
    sortPrice() {
      this.sort_price = this.sort_price ? 0 : 1;
      this.getList();
    },
    switchType(type) {
      this.category = type;
      this.search_name = "";
      this.sub_catetory_name = "";
      this.sub_catetoryId = 0;
      this.page = 1;
      if (this.isFirst) {
        // 控制第一次进来时点击武器分类将价格区间置为零，后续切换不处理
        this.isFirst = false;
        this.price_range = 0;
      }
      this.getList();
    },
    async getList() {
      var minprice = 0;
      var maxprice = 9999999;

      switch (this.price_range) {
        case 1:
          minprice = 0;
          maxprice = 50;
          break;
        case 2:
          minprice = 50;
          maxprice = 200;
          break;
        case 3:
          minprice = 200;
          maxprice = 1000;
          break;
        case 4:
          minprice = 1000;
          maxprice = 2000;
          break;
        case 5:
          minprice = 2000;
          maxprice = 10000;
          break;
        case 6:
          minprice = 10000;
          maxprice = 9999999;
          break;
        default:
          minprice = 0;
          maxprice = 9999999;
          break;
      }

      var params = {
        cat: this.category,
        page: this.page,
        size: this.pageSize,
        sort: this.sort_price,
        name: this.search_name,
        sub_type: this.sub_catetory_name,
        minprice,
        maxprice,
      };

      if (this.currentShopType === 'shopVip') {
        params.marketGatewayCode = 4;
      } else if (this.currentShopType === 'shopUu') {
        params.marketGatewayCode = 2;
      } else if (this.currentShopType === 'shopHappyCoin') {
        params.marketGatewayCode = 5;
      } else if (this.currentShopType === 'shopCoin1') {
        params.marketGatewayCode = 6;
      }

      var respone = await api_GetStoreItemList(params);
      this.setSpinShow(false);
      this.list_assets_data.items = respone.data.data.data

      this.totalPage = Math.ceil(respone.data.data.totalItems / this.pageSize);
      this.totalItems = respone.data.data.totalItems;
    },
    addToCart(item) {
      this.cartItemList.unshift(item);
    },
    cartRemoveItem(index) {
      this.cartItemList.splice(index, 1);
    },
    clearCart() {
      this.cartItemList = [];
    },
    openBuyModal(item) {
      if (item) {
        this.confirm_modal.price = item.price;
        this.confirm_modal.item = item;
      } else {
        //购物车
        this.confirm_modal.price = this.totalCartPice;
        this.confirm_modal.item = null;
      }

      this.confirm_modal.flag = true;
    },
    submit_buy() {
      var lstItem = [];
      if (this.confirm_modal.item)
        //单选物品
        lstItem = [this.confirm_modal.item.id];
      else lstItem = this.cartItemList.map((item) => item.id);

      const params = { val: lstItem };
      if (this.currentShopType === 'shopVip' || this.currentShopType === 'shopHappyCoin' || this.currentShopType === 'shopCoin1') {
        params.onlyBuy = true;
      }

      api_StoreBuyItem(params).then((res) => {
        if (res.data.code === 0) {
          if (!this.confirm_modal.item) this.cartItemList = [];

          this.$toast.success("购买成功");
          this.$store.commit("setInfo");
          this.confirm_modal.flag = false;
        } else {
          this.$toast.error(res.data.msg);

          if (res.data.msg.indexOf("充值") > -1) {
            this.$store.commit("setPayModal", true);
          }
        }
      });
    },
    onGotoShop(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    }
  },
};
